// Customizable Area Start
import React from "react";
import { Box, styled } from "@mui/material"
import EmailVerificationController, {
  Props,
} from "./EmailVerificationController.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";

const ContentContainer = styled(Box)({
    minHeight: "75vh",
    backgroundColor: "#EFF6FF"
})
// Customizable Area End

export default class EmailVerification extends EmailVerificationController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  // Customizable Area Start
  render() {
    const { navigation } = this.props;
    const { isLoading, isInfoDialogOpen, infoType, infoMessage } = this.state;
    return (
      <>
        <FullPageLoader isLoading={isLoading} />
        <NavigationMenu navigation={navigation} id={""} />

        <ContentContainer />
        <AppFooter navigation={navigation} />

        <CustomInfoDialog
          isOpen={isInfoDialogOpen}
          infoType={infoType}
          title={infoMessage}
          handleClose={this.closeInfoDialog}
        />
      </>
    );
  }
  // Customizable Area End
}
